<template>
  <div>
    <!-- 课长决策 -->
    <el-dialog title="课长决策" :close-on-click-modal="false" :visible.sync="dialogVisible" width="680px" center>
      <div class="content">
        <el-form :model="form" :rules="rules" ref="form" label-width="130px">
          <!-- 是否投诉： -->
          <el-form-item label="是否投诉：:" prop="is_complaint" v-if="form.chat_type">
            <el-radio-group v-model="form.is_complaint">
              <el-radio :label="1">非投诉</el-radio>
              <el-radio :label="2">确认投诉</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- 问题分类-->
          <el-form-item label="问题分类:" prop="problem_category">
            <el-select v-model="form.problem_category" placeholder="请选择问题分类">
              <el-option v-for="(item, index) in problemCategoy" :label="item.value" :value="item.value" :key="index" />
            </el-select>
          </el-form-item>
          <!-- *售后问题说明 -->
          <el-form-item label="处理方案:" prop="leader_solution">
            <el-input v-model="form.leader_solution" placeholder="处理方案" type="textarea" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">
          {{ $t("message.cancel") }}
        </el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">
          {{ $t("message.ok") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    problemCategoy: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      form: {
        is_complaint: '',
        leader_solution: '',
        problem_category: '',
      },
      rules: {
        leader_solution: [{ required: true, message: '请输入处理方案', trigger: 'blur' }],
        problem_category: [{ required: true, message: '请选择问题分类', trigger: 'blur' }],
        is_complaint: [{ required: true, message: '请选择是否投诉', trigger: 'blur' }],
      },
      dialogVisible: false,
    };
  },
  methods: {
    // 保存
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$api.siteConfiguration.aftersaleIssueLeaderDecision(this.form).then(res => {
            this.$message.success(res.msg);
            this.$parent.aftersaleIssueList();
            this.$parent.aftersaleIssueStatusStatistics();
            this.dialogVisible = false;
          })
        } else {
          this.$message.error('请填写完整信息');
        }
      })
    },


  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;

  .row {
    display: flex;

    .input {
      width: 300px;
      margin-right: 20px;
    }
  }

  .image {
    display: flex;
    flex-wrap: wrap;

    .image-item {
      position: relative;
      margin-bottom: 10px;
      margin-right: 10px;

      .el-icon-error {
        position: absolute;
        top: -5px;
        right: -5px;
        font-size: 20px;
        color: #ff4949;
        cursor: pointer;
      }
    }

    .avatar {
      width: 80px;
      height: 80px;
      border-radius: 4px;

    }
  }

  .avatar-uploader {
    height: 80px;
    width: 80px;
  }

  /deep/.el-upload--picture-card {
    width: 80px;
    height: 80px;
    line-height: 80px;
  }

  /deep/.el-textarea__inner {
    height: 100px;
  }

  .list {
    margin-top: 10px;

    p {
      line-height: 30px;
    }
  }
}
</style>